import React, { PureComponent, Fragment } from 'react';
import { Link } from 'react-router-dom';
import * as Func from '../../../../../helpers/functions';
import { PATHS } from '../../../../../constants/Define';
import { ListComponent, StatusComponent } from "../../../common/component/Index";
import Model from '../../../../../models/RoomType';
import { withTranslation } from "react-i18next";
import { Icon, Rate } from 'antd';
import Ripple from '../../../common/component/Ripple';
import RoomType from '../../../../../models/RoomType';
import { FlagIcons } from '../../../common/component/TranslateButton';

const ListCols = ['name', 'area', 'code', 'maxOccupancy', 'isActive', 'translations'];
const ModelFields = Object.getOwnPropertyNames(new RoomType());

class RoomTypeList extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            titleItemTable: Func.getTitleTable(ListCols, ['action'], []),
            modelItem: ModelFields,
            componentTable: {
                name: {
                    key: 'name',
                },
                code: {
                    key: 'code',
                    align: 'center',
                },
                maxOccupancy: {
                    key: 'maxOccupancy',
                    align: 'center',
                },
                isActive: {
                    key: 'active',
                    render: (isActive) => (
                        <StatusComponent color={isActive ? 'green' : 'red'}
                            label={isActive ? this.props.t('item.roomType.active') : this.props.t('item.roomType.deactive')} />
                    )
                },
                translations: {
                    key: 'translations',
                    width: 120,
                    render: (text, record) => {
                        const filteredTranslation = record.translations.filter((item, index, self) =>
                            index === self.findIndex((t) => (
                                t.languageCode === item.languageCode
                            ))
                        );
                        return <FlagIcons languages={filteredTranslation} />
                    },
                },
                action: {
                    width: 100,
                    align: 'center',
                    key: 'action',
                    render: (text, record) => this.renderEditComponent(record),
                }
            },
            filters: {},
        };
    }

    render() {
        const { loading, pagination, dataList } = this.props;
        const { titleItemTable, modelItem, componentTable } = this.state;
        return (
            <ListComponent
                tableKey="room-type-list"
                // scroll={{ x: 1200 }}
                classChildren="p-0" classParent="m-0"
                rowKey={(record, k) => record.id ? record.id : k}
                loading={{ spinning: loading, size: 'large' }}
                dataSource={Func.getDataSource(dataList || [], modelItem)}
                columns={Func.columnsTable({
                    titleTable: titleItemTable,
                    component: componentTable,
                    itemName: 'roomType'
                })}
                onChange={this.props.onChange}
                pagination={{ total: pagination.totalCount, totalPage: pagination.totalPage, defaultCurrent: pagination.defaultCurrent }}
                componentTableList={{}}
            />
        );
    }

    renderEditComponent(item) {
        const { t, permisions, hotelId } = this.props;
        const onRemove = () => {
            if (confirm(Func.formatValidation(t('validation.statusCode.code.7'), t(`item.roomType.title`)))) { //eslint-disable-line
                return this.props.onDeleteRoomType && this.props.onDeleteRoomType(item)
            }
        };
        return (
            <Fragment>
                {
                    permisions && permisions.allowUpdate &&
                    <Link to={Func.getPathWithParams(PATHS.ROOM_TYPE.DETAIL.path, { hotel_id: hotelId, id: item.id })} className={`mr-2 colorPrimary`}>
                        <Ripple><Icon type="form" className="fs20" /></Ripple>
                    </Link>
                }
                {/* {
                    permisions && permisions.allowDelete &&
                    <Ripple onClick={onRemove}><Icon type="delete" className="fs20 colorPrimary" /></Ripple>
                } */}
            </Fragment>
        )
    }


}

export default withTranslation()(RoomTypeList);
